import { AutomationGroups } from '@/modules/listGroupFeed/domain/models/GetAutomationGroups'

import { axios, Response } from '..'

const getPermissionsGroup = (): Response<AutomationGroups[]> => {
  return axios.get(`/v1/automation-groups`)
}
export default getPermissionsGroup
